import React, { useState, useEffect } from "react";
import Icon from "../../components/ui/icon";
import "../../assets/styles/pages/publishers/home.css";
import "../../assets/styles/component/chart/chart.css";
import { useToast } from "../../context/toastContext";
import { useNavigate } from "react-router-dom";
import api from "../../services/apiClient";
import moment from "moment-timezone";
import AdminSideNav from "../../components/layout/adminSideNav";
import CountUp from "../../components/ui/CountUp";
import { storageManager } from "../../utils/storageManager";
import { convertCurrency } from "../../utils/currencyConverter";
import { getTimezoneByCountry } from "../../utils/getTimezoneByCountry";

const AdminHomePage = () => {

  const [chartDataStatus, setChartDataStatus] = useState("loading");
  const navigate = useNavigate();
  const showToast = useToast();
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("AdminInfo")) || {}
  );
  const country = userInfo?.country?.toLowerCase() || "india";
  const currency = storageManager.getCurrency();
  const [isSideNavActive, setisSideNavActive] = useState(false);
  const [data, setData] = useState([
    {
      day: moment().tz(getTimezoneByCountry(country)).subtract(6, "days").format("ddd"),
      clicks: 0,
      conversion: 0,
      revenue: 0,
    },
    {
      day: moment().tz(getTimezoneByCountry(country)).subtract(5, "days").format("ddd"),
      clicks: 0,
      conversion: 0,
      revenue: 0,
    },
    {
      day: moment().tz(getTimezoneByCountry(country)).subtract(4, "days").format("ddd"),
      clicks: 0,
      conversion: 0,
      revenue: 0,
    },
    {
      day: moment().tz(getTimezoneByCountry(country)).subtract(3, "days").format("ddd"),
      clicks: 0,
      conversion: 0,
      revenue: 0,
    },
    {
      day: moment().tz(getTimezoneByCountry(country)).subtract(2, "days").format("ddd"),
      clicks: 0,
      conversion: 0,
      revenue: 0,
    },
    {
      day: moment().tz(getTimezoneByCountry(country)).subtract(1, "days").format("ddd"),
      clicks: 0,
      conversion: 0,
      revenue: 0,
    },
    {
      day: moment().tz(getTimezoneByCountry(country)).format("ddd"),
      clicks: 0,
      conversion: 0,
      revenue: 0,
    },
  ]);
  useEffect(() => {
    const token = localStorage.getItem("aToken");
    if (!token) {
      navigate("/auth/login");
      return;
    }

    api
      .get(`/api/admin/info`)
      .then((response) => {
        setUserInfo(response.data.data);
        localStorage.setItem("AdminInfo", JSON.stringify(response.data.data));
        getChartData();
      })
      .catch((err) => {
        showToast({
          status: "error",
          message: err.response?.data?.message || "Login not found.",
        });
        navigate("/auth/login");
      });

    const getChartData = () => {
      const end = moment().tz(getTimezoneByCountry(country)).format("YYYY-MM-DD");
      const start = moment()
        .tz(getTimezoneByCountry(country))
        .subtract(6, "days")
        .format("YYYY-MM-DD");

      api
        .get(`/api/admin/get-report?start=${start}&end=${end}&extractBy=daily`)
        .then((response) => {
          const breakdown = response.data.data.dailyBreakdown || [];

          const updatedData = [];

          let i = 0;
          breakdown.forEach((entry) => {
            const dayName = moment(entry.date).tz(getTimezoneByCountry(country)).format("ddd");
            updatedData[i] = {
              day: dayName,
              clicks: entry.totalClicks || 0,
              conversion: entry.totalConversions || 0,
              revenue: convertCurrency(entry.totalRevenue, userInfo?.currency || "USD", currency, true) || 0,
            };
            i++;
          });

          setData(updatedData);
          setChartDataStatus("loaded");
        })
        .catch((err) => {
          showToast({
            status: "error",
            message:
              err.response?.data?.message || "Unable to get weekly data.",
          });
        });
    };
  }, [navigate, showToast, country, currency, userInfo?.currency]);

  const maxValue = Math.max(
    ...data.flatMap((d) => [d.clicks, d.conversion, d.revenue])
  );

  const getGreetingByTimezone = (timeZone = "UTC") => {
    const now = new Date();

    const localHour = Number(
      now.toLocaleString("en-US", {
        timeZone,
        hour: "2-digit",
        hour12: false,
      })
    );

    if (localHour >= 5 && localHour < 12) {
      return "Good Morning";
    }

    if (localHour >= 12 && localHour < 17) {
      return "Good Afternoon";
    }

    if (localHour >= 17 && localHour < 21) {
      return "Good Evening";
    }

    return "Good Night";
  }

  const getFirstName = (fullName = "") => {
    if (!fullName) return "";
    return fullName.trim().split(/\s+/)[0];
  }

  return (
    <div className="home__page">
      <AdminSideNav
        userName={userInfo.name}
        emailID={userInfo.email}
        active={isSideNavActive}
        isOnHome={true}
      />
      <div
        onClick={() => setisSideNavActive(!isSideNavActive)}
        className={
          isSideNavActive ? "background-shadow active" : "background-shadow"
        }
      ></div>
      <main>
        <header className="desktop-header">
          <div>
            <h2>{getGreetingByTimezone(getTimezoneByCountry(country))}, {getFirstName(userInfo.name)}!</h2>
            <p>Track your growth more effectively.</p>
          </div>
          <button>
            <Icon name="Document" className="onLeft" /> Export
          </button>
        </header>

        <header className="mobile-header">
          <div>
            <h2>Dashboard</h2>
          </div>
          <button
            className="nav-btn"
            onClick={() => setisSideNavActive(!isSideNavActive)}
          >
            {isSideNavActive ? (
              <Icon name="XMark" className="onLeft" />
            ) : (
              <Icon name="Bars3" className="onLeft" />
            )}
          </button>
        </header>

        <div className="cards-container">
          <div className="card">
            <div>
              <Icon name="CursorArrowRays" /> Today's Clicks
            </div>
            <span className="data">
              <CountUp
                value={userInfo?.reports?.clicks?.today || 0}
                decimals={true}
                duration={1500}
                formatShort={true}
              />
            </span>
            <span>
              <span className={`yesRate ${userInfo?.reports?.clicks?.dayOverDayChange < 0 ? "less" : "more"}`}>{userInfo?.reports?.clicks?.dayOverDayChange >= 0 ? "+" : ""}{userInfo?.reports?.clicks?.dayOverDayChange || "0"}%</span> than yesterday.
            </span>
          </div>
          <div className="card">
            <div>
              <Icon name="Check" /> Today's Conversion
            </div>
            <span className="data">
              <CountUp
                value={userInfo?.reports?.conversions?.today || 0}
                decimals={true}
                duration={1500}
                formatShort={true}
              />
            </span>
            <span>
              <span className={`yesRate ${userInfo?.reports?.conversions?.dayOverDayChange < 0 ? "less" : "more"}`}>{userInfo?.reports?.conversions?.dayOverDayChange >= 0 ? "+" : ""}{userInfo?.reports?.conversions?.dayOverDayChange || "0"}%</span> than yesterday.
            </span>
          </div>
          <div className="card">
            <div>
              <Icon name="ArrowPath" /> CR Rate
            </div>
            <span className="data">
              <CountUp
                value={parseFloat(userInfo?.reports?.crRate?.today) || 0}
                decimals={true}
                suffix="%"
                duration={1500}
              />
            </span>
            <span>
              <span className={`yesRate ${userInfo?.reports?.crRate?.dayOverDayChange < 0 ? "less" : "more"}`}>{userInfo?.reports?.crRate?.dayOverDayChange >= 0 ? "+" : ""}{userInfo?.reports?.crRate?.dayOverDayChange || "0"}%</span> than yesterday.
            </span>
          </div>
          <div className="card">
            <div>
              <Icon name="BankNotes" /> Today's Revenue
            </div>
            <span className="data">
              <CountUp
                value={convertCurrency(
                  userInfo?.reports?.revenue?.today || 0,
                  userInfo?.reports?.revenue?.currency || "USD",
                  currency,
                  true
                ) || 0}
                prefix={currency === "INR" ? "₹" : currency === "USD" ? "$" : currency === "EUR" ? "€" : "₹"}
                decimals={true}
                duration={1500}
                formatShort={true}
                decimalsSmall={true}
              />
            </span>
            <span>
              <span className={`yesRate ${userInfo?.reports?.revenue?.dayOverDayChange < 0 ? "less" : "more"}`}>{userInfo?.reports?.revenue?.dayOverDayChange >= 0 ? "+" : ""}{userInfo?.reports?.revenue?.dayOverDayChange || "0"}%</span> than yesterday.
            </span>
          </div>
          <div className="card">
            <div>
              <Icon name="ArrowUpRight" /> Today's Profit
            </div>
            <span className="data">
              {convertCurrency(0, "INR", currency, false) || "₹0"}
            </span>
            <span>
              Under Development
            </span>
          </div>
        </div>

        <div className="charts-section">
          <div className="top">
            <div>
              <h2>Reports</h2>
              <p>Check how's your campaigns are performing.</p>
            </div>
            <button>
              This Week <Icon name="ChevronDown" className="onRight" />{" "}
            </button>
          </div>

          <div className="chart-container">
            <div className="chart-bars">
              {data.map((day, index) => (
                <div className="chart-bar-wrapper" key={index}>
                  <div className="chart-bar-container">
                    <div
                      className="chart-bar-1"
                      style={{
                        "--clicks": `${(day.clicks / maxValue) * 100}%`,
                      }}
                    >
                      <div className="tooltip">
                        <h3>Clicks</h3>
                        <span>{day.clicks}</span>
                      </div>
                    </div>
                    <div
                      className="chart-bar-2"
                      style={{
                        "--conversion": `${(day.conversion / maxValue) * 100}%`,
                      }}
                    >
                      <div className="tooltip">
                        <h3>Conversion</h3>
                        <span>{day.conversion}</span>
                      </div>
                    </div>
                    <div
                      className="chart-bar-3"
                      style={{
                        "--revenue": `${(day.revenue /
                          maxValue) *
                          100
                          }%`,
                      }}
                    >
                      <div className="tooltip">
                        <h3>Revenue</h3>
                        <span>
                          {currency === "INR"
                            ? "₹"
                            : currency === "USD"
                              ? "$"
                              : currency === "EUR"
                                ? "€"
                                : "₹"}
                          {day.revenue}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="chart-day">{day.day}</div>
                </div>
              ))}
              {maxValue === 0 && (
                <div className="no-data-message">
                  {chartDataStatus === "loading" ? (
                    <>
                      <Icon name="ArrowPath" className="small-icon-spin" />
                      <p>Fetching data please wait.</p>
                    </>
                  ) : chartDataStatus === "failed" ? (
                    <>
                      <Icon name="InformationCircle" />
                      <p>Unable to fetch data.</p>
                    </>
                  ) : (
                    <>
                      <Icon name="InformationCircle" />
                      <p>There is no click,conversion or revenue to show.</p>
                    </>
                  )}
                </div>
              )}
            </div>
            <div className="chart-bars-info">
              <div className="chart-bar-info">
                <span className="bar-color"></span>
                <span className="bar-text">Clicks</span>
              </div>
              <div className="chart-bar-info">
                <span className="bar-color"></span>
                <span className="bar-text">Conversion</span>
              </div>
              <div className="chart-bar-info">
                <span className="bar-color"></span>
                <span className="bar-text">Revenue</span>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminHomePage;
